import {lazy} from "react";
import {IComponentTypeMapping} from "./ComponentType";

// eslint-disable-next-line import/prefer-default-export
export const ComponentTypeMappings: IComponentTypeMapping = {
    // ========= Dashboard Components ==============
    SparkLineValueIndicator: {
        name: "Spark Line Value Indicator",
        dashboardComponent: true,
        entryPoint: () => import("./dashboard/sparkline/SparkLine" /* webpackChunkName: "spark-line" */),
        editorEntryPoint: lazy(() => import("./dashboard/sparkline/SparkLineEditor") /* webpackChunkName: "spark-line-editor" */)
    },
    DatasetCollapseDataTable: {
        name: "Dataset Collapse Data Table",
        dashboardComponent: true,
        entryPoint: () => import("./dashboard/dataset-collapse-data-table/DatasetCollapseDataTable" /* webpackChunkName: "dataset-collapse-data-table" */),
        editorEntryPoint: lazy(() => import("./dashboard/dataset-collapse-data-table/dataset-collapse-data-table-editor/DatasetCollapseDataTableEditor") /* webpackChunkName: "dataset-collapse-data-table-editor" */)
    },
    MeasurementDeviceTableAgreg: {
        name: "Measurement Device Table Aggregated",
        dashboardComponent: true,
        entryPoint: () => import("./dashboard/measurement-device-table-agreg/MeasurementDeviceTableAgreg" /* webpackChunkName: "measurement-device-table-agreg" */)
    },
    DatasetIndicator: {
        name: "Dataset Gauge Indicator",
        dashboardComponent: true,
        entryPoint: () => import("./dashboard/dataset-indicator/DatasetIndicator" /* webpackChunkName: "dataset-indicator" */)
    },
    ProductTemplateTable: {
        name: "Product Template Table",
        dashboardComponent: true,
        supportsStatusCallback: true,
        entryPoint: () => import("./dashboard/product-template-table/ProductTemplateTable" /* webpackChunkName: "product-template-table" */),
        editorEntryPoint: lazy(() => import("./dashboard/product-template-table/product-template-table-editor/ProductTemplateTableEditor") /* webpackChunkName: "product-template-table-editor" */)
    },
    DatasetLineChart: {
        name: "Dataset Line Chart",
        dashboardComponent: true,
        supportsStatusCallback: true,
        entryPoint: () => import("./dashboard/charts/dataset-line-chart/DatasetLineChart" /* webpackChunkName: "dataset-line-chart" */),
        editorEntryPoint: lazy(() => import("./dashboard/charts/dataset-line-chart/DatasetLineChartEditor") /* webpackChunkName: "dataset-line-chart-editor" */)
    },
    DatasetHistogramChart: {
        name: "Dataset Histogram Chart",
        dashboardComponent: true,
        entryPoint: () => import("./dashboard/charts/histogram/HistogramChart" /* webpackChunkName: "dataset-histogram-chart" */),
        editorEntryPoint: lazy(() => import("./dashboard/charts/histogram/histogram-editor/HistogramChartEditor") /* webpackChunkName: "dataset-histogram-chart-editor" */),
    },
    DatasetBarChart: {
        name: "Dataset Bar Chart",
        dashboardComponent: true,
        entryPoint: () => import("./dashboard/charts/bar-chart/DatasetBarChartRenderer" /* webpackChunkName: "dataset-bar-chart-renderer" */),
        editorEntryPoint: lazy(() => import("./dashboard/charts/bar-chart/bar-editor/DatasetBarChartEditor") /* webpackChunkName: "dataset-bar-chart-editor" */)
    },
    GridHeatMap: {
        name: "Dataset Grid Heatmap",
        dashboardComponent: true,
        entryPoint: () => import("./dashboard/grid-heatmap/GridHeatmap" /* webpackChunkName: "grid-heatmap" */),
        editorEntryPoint: lazy(() => import("./dashboard/grid-heatmap/grid-heatmap-editor/GridHeatmapEditor") /* webpackChunkName: "grid-heatmap-editor" */),
      },
    DatasetScatterChart: {
        name: "Dataset Scatter Chart",
        dashboardComponent: true,
        supportsStatusCallback: true,
        entryPoint: () => import("./dashboard/charts/dataset-scatter-chart/DatasetScatterChart" /* webpackChunkName: "dataset-scatter-chart" */),
        editorEntryPoint: lazy(() => import("./dashboard/charts/dataset-scatter-chart/DatasetScatterChartEditor") /* webpackChunkName: "dataset-scatter-chart-editor" */)
    },
    DatasetPieChart: {
        name: "Dataset Pie Chart",
        dashboardComponent: true,
        supportsStatusCallback: true,
        entryPoint: () => import("./dashboard/charts/DatasetPieChart" /* webpackChunkName: "dataset-pie-chart" */),
        editorEntryPoint: lazy(() => import("./dashboard/charts/dataset-pie-chart/DatasetPieChartEditor") /* webpackChunkName: "dataset-pie-chart-editor" */)
    },
    DatasetSankeyChart: {
        name: "Dataset Sankey Chart",
        dashboardComponent: true,
        supportsStatusCallback: true,
        entryPoint: () => import("./dashboard/charts/sankey-chart/Sankey" /* webpackChunkName: "dataset-sankey-chart" */),
        editorEntryPoint: lazy(() => import("./dashboard/charts/sankey-chart/sankey-editor/SankeyEditor") /* webpackChunkName: "dataset-sankey-chart-editor" */)
    },
    DataInputOutputTable: {
        name: "Data Input Output Table",
        dashboardComponent: true,
        entryPoint: () => import("./dashboard/data-input-output-table/main-table/DataInputOutputTable" /* webpackChunkName: "data-input-output-table" */),
        editorEntryPoint: lazy(() => import("./dashboard/data-input-output-table/data-input-output-table-editor/DataInputOutputTableEditor") /* webpackChunkName: "data-input-output-table-editor" */)
    },
    Scada: {
        name: "SCADA",
        dashboardComponent: true,
        entryPoint: () => import("./dashboard/scada/Scada" /* webpackChunkName: "scada" */),
        editorEntryPoint: lazy(() => import("./dashboard/scada/scada-editor/ScadaEditor") /* webpackChunkName: "scada-editor" */)
    },
    DatasetToggleTable: {
        name: "Dataset Toggle Table",
        dashboardComponent: true,
        entryPoint: () => import("./dashboard/dataset-toggle-table/DatasetToggleTable" /* webpackChunkName: "dataset-toggle-table" */)
    },
    DatasetSetpointTable: {
        name: "Dataset Setpoint Table",
        dashboardComponent: true,
        entryPoint: () => import("./dashboard/dataset-setpoint-table/DatasetSetpointTable" /* webpackChunkName: "dataset-setpoint-table" */),
        editorEntryPoint: lazy(() => import("./dashboard/dataset-setpoint-table/dataset-setpoint-table-editor/DatasetSetpointTableEditor") /* webpackChunkName: "dataset-setpoint-table-editor" */)
    },
    CalendarHeatmap: {
      name: "Calendar Heatmap",
      dashboardComponent: true,
      entryPoint: () => import("./dashboard/calendar-heatmap/CalendarHeatmap" /* webpackChunkName: "calendar-heatmap" */),
      editorEntryPoint: lazy(() => import("./dashboard/calendar-heatmap/calendar-heatmap-editor/CalendarHeatmapEditor") /* webpackChunkName: "calendar-heatmap-editor" */),
    },
    DatasetTable: {
        name: "Dataset Table",
        dashboardComponent: true,
        supportsStatusCallback: true,
        entryPoint: () => import("./dashboard/dataset-table/DatasetTable" /* webpackChunkName: "dataset-table" */),
        editorEntryPoint: lazy(() => import("./dashboard/dataset-table/dataset-table-editor/DatasetTableEditor") /* webpackChunkName: "dataset-table-editor" */)
    },
    EapsmLicenceManager: {
        name: "Eapsm License Manager",
        dashboardComponent: true,
        entryPoint: () => import("./dashboard/eapsm-license-manager/EapsmLicenseManager" /* webpackChunkName: "eapsm-license-manager" */)
    },
    FreeText: {
        name: "Free Text",
        dashboardComponent: true,
        entryPoint: () => import("./pages/dashboard/components/free-text/FreeText" /* webpackChunkName: "free-text" */),
        editorEntryPoint: lazy(() => import("./pages/dashboard/components/free-text/FreeTextEditor") /* webpackChunkName: "free-text-editor" */)
    },
    GeneratedReportTable: {
        name: "Generated Report Table",
        dashboardComponent: true,
        entryPoint: () => import("./dashboard/generated-report-table/GeneratedReportTable" /* webpackChunkName: "generated-report-table" */),
        editorEntryPoint: lazy(() => import("./dashboard/generated-report-table/generated-report-table-editor/GeneratedReportTableEditor") /* webpackChunkName: "generated-report-table-editor" */)
    },
    AlertFan: {
        name: "Alert Fan",
        dashboardComponent: true,
        entryPoint: () => import("./dashboard/alert-fan/AlertTabMain" /* webpackChunkName: "alert-fan-tab" */),
        editorEntryPoint: lazy(() => import("./dashboard/alert-fan/AlertFanEditor" /* webpackChunkName: "alert-fan-editor" */))
    },
    PIDController: {
        name: "PID Controller",
        dashboardComponent: true,
        entryPoint: () => import("./dashboard/pid-controller/PIDController" /* webpackChunkName: "pid-controller" */),
        editorEntryPoint: lazy(() => import("./dashboard/pid-controller/PIDControllerEditor") /* webpackChunkName: "pid-controller-editor" */)
    },
        DashboardRedirectButton: {
        name: "Dashboard Redirect Button",
        dashboardComponent: true,
        entryPoint: () => import("./dashboard/redirect-button/DashboardRedirectButton" /* webpackChunkName: "dashboard-redirect-button" */),
        editorEntryPoint: lazy(() => import("./dashboard/redirect-button/DashboardRedirectButtonEditor") /* webpackChunkName: "dashboard-redirect-button-editor" */)
    },
    Separator: {
        name: "Separator",
        dashboardComponent: true,
        entryPoint: () => import("./dashboard/separator/Separator" /* webpackChunkName: "separator" */),
        editorEntryPoint: lazy(() => import("./dashboard/separator/SeparatorEditor") /* webpackChunkName: "separator-editor" */)
    },
    InstantJobEnqueueConfigurator: {
        name: "Instant Job Enqueue Configurator",
        dashboardComponent: true,
        entryPoint: () => import("./company-specific/viking-malt/best-batch-calculator/VikingMaltBestBatchCalculator" /* webpackChunkName: "instant-job-enqueue-configurator" */)
    },
    DevicesMap: {
        name: "Devices Map",
        dashboardComponent: true,
        entryPoint: () => import("./dashboard/devices-map/DevicesMap" /* webpackChunkName: "devices-map" */),
    },
    LastKnownValueTimeMoment: {
        name: "Last Known Value Time Moment",
        dashboardComponent: true,
        entryPoint: () => import("components/dashboard/last-known-value-time-moment/LastKnownValueTimeMoment" /* webpackChunkName: "last-known-value-time-moment" */),
        editorEntryPoint: lazy(() => import("components/dashboard/last-known-value-time-moment/LastKnownValueTimeMomentEditor" /* webpackChunkName: "last-known-value-time-moment-editor" */))
    },
    WeatherMonitoring: {
        name: "Weather Monitoring",
        dashboardComponent: true,
        entryPoint: () => import("components/dashboard/weather-monitoring/WeatherMonitoring" /* webpackChunkName: "weather-monitoring" */),
        editorEntryPoint: lazy(() => import("components/dashboard/weather-monitoring/WeatherMonitoringEditor" /* webpackChunkName: "weather-monitoring-editor" */))
    },
    DatasetStatusMonitoring: {
        name: "Dataset Status Monitoring",
        dashboardComponent: true,
        entryPoint: () => import("components/dashboard/dataset-status-monitoring/DatasetStatusMonitoring" /* webpackChunkName: "dataset-status-monitoring" */),
        editorEntryPoint: lazy(() => import("components/dashboard/dataset-status-monitoring/DatasetStatusMonitoringEditor" /* webpackChunkName: "dataset-status-monitoring-editor" */))
    },

    // ==================== Page Fragments ====================
    DashboardComponentConfigurator: {
        name: "Dashboard Component Configurator",
        dashboardComponent: false,
        entryPoint: () => import("./fragments/DashboardComponentConfigurator" /* webpackChunkName: "dashboard-component-configurator" */)
    },
    DashboardFragment: {
        name: "Dashboard fragment",
        dashboardComponent: false,
        entryPoint: () => import("./fragments/dashboard/DashboardFragment" /* webpackChunkName: "dashboard-fragment" */)
    },
    ProductTemplateConfiguratorJson: {
        name: "Product Template Configurator (JSON)",
        dashboardComponent: false,
        entryPoint: () => import("./fragments/product-template-configurator/ProductTemplatesConfiguratorJson" /* webpackChunkName: "prod-templates-configurator" */)
    },
    DataWindowChart: {
        name: "Data Window Chart",
        dashboardComponent: false,
        entryPoint: () => import("./fragments/DataWindowChart" /* webpackChunkName: "data-window-chart" */)
    },
    ProductTemplateDataManagerFragment: {
        name: "Product Template Data Manager",
        dashboardComponent: false,
        entryPoint: () => import("./fragments/ProductTemplateDataManagerFragment" /* webpackChunkName: "product-template-data-manager" */)
    },
    CompanyContextSelect: {
        name: "Company Context Select",
        dashboardComponent: false,
        entryPoint: () => import("./fragments/company-context-select/CompanyContextSelect" /* webpackChunkName: "company-context-select" */)
    },

    EasasGlobalFragment: {
        name: "Global Fragment",
        invisible: true,
        entryPoint: () => import("./fragments/easas-global-fragment/EasasGlobalFragment" /* webpackChunkName: "product-template-data-manager" */),
    },

  // ==================== Pages ====================
  EasasMain: {
    name: "Easas Main",
    dashboardComponent: false,
    entryPoint: () => import("./pages/easas-main/EasasMain" /* webpackChunkName: "easas-main" */),
  } ,
  ScheduleBookingPage: {
    name: "ScheduleBookingPage",
    dashboardComponent: false,
    entryPoint: () =>
      import("./pages/schedule-booking/ScheduleBooking" /* webpackChunkName: "schedule-booking" */),
  },
  ScheduledAirflowTaskConfigPage: {
    name: "Scheduled Task Config",
    dashboardComponent: false,
    entryPoint: () =>
      import(
        "./pages/scheduled-task-airflow/AirflowTaskConfigurator" /* webpackChunkName: "scheduled-airflow-task-config-page" */
      ),
  },
  DatasetPage: {
    name: "Datasets",
    dashboardComponent: true,
    entryPoint: () => import("./dashboard/dataset-window" /* webpackChunkName: "dataset-window" */),
  },
  DashboardReportsPage: {
    name: "DashboardReportsPage",
    dashboardComponent: false,
    entryPoint: () =>
      import(
        "./pages/dashboard-report/DashboardReportPage" /* webpackChunkName: "dashboard-reports-page" */
      ),
  },
  UserSessionStatsPage: {
    name: "User Session Stats Page",
    dashboardComponent: false,
    entryPoint: () =>
      import(
        "./pages/users-statistics-dashboard/UsersStatisticsDashboard" /* webpackChunkName: "dashboard-reports-page" */
      ),
  },
  CompanyFilesPage: {
    name: "Company Files Page",
    entryPoint: () =>
      import("./pages/company-files/CompanyFilesPage" /* webpackChunkName: "company-files-page" */),
  },
  MeasurementDeviceManagementPage: {
    name: "Measurement Devices",
    entryPoint: () =>
      import(
        "components/pages/measurement-devices/MeasurementDevicesRoot" /* webpackChunkName: "measurement-devices-management" */
      ),
  },

  // ========= Dev ==============
  ReactExample: {
    name: "DEV TEST",
    dashboardComponent: true,
    entryPoint: () => import("./dashboard/test/App" /* webpackChunkName: "react-example" */),
  },
  FailingComponentTest: {
    name: "Fail Test component",
    dashboardComponent: true,
    supportsStatusCallback: true,
    entryPoint: () =>
      import(
        "components/dashboard/failing-component-test/FailingComponentTest" /* webpackChunkName: "failing-component-test" */
      ),
  },
  DevSandbox: {
    name: "Dev Sandbox",
    dashboardComponent: true,
    entryPoint: () => import("./dashboard/dev-sandbox/DevSandbox" /* webpackChunkName: "dev-sandbox" */),
  },
};


export const dashboardComponentOptions = Object.keys(ComponentTypeMappings)
.filter(key => ComponentTypeMappings[key].dashboardComponent)
.map(key => ({
  name: ComponentTypeMappings[key].name,
  id: key,
}));